import { observable, action } from 'mobx';
import { Entity, AccelFile } from '..';
import { RegistrationConsent, RegistrationConsentDraft } from './RegistrationConsent';
import { FormCaptchaType } from '../captcha/FormCaptcha';

// TODO move to school project
export default class SchoolSettings extends Entity {
    constructor(settings?: Partial<SchoolSettings>) {
        super(settings);
        if (settings) this.update(settings);
    }

    // TODO @predefined
    @observable isRegistrationAgreementEnabled: boolean;
    @observable registrationAgreementText: string | null
    @observable isCookieNotificationEnabled: boolean;
    @observable cookieNotificationText: string | null
    @observable footerHtml: string | null;
    @observable isPageFooterEnabled: boolean;
    @observable isLearnPageFooterEnabled: boolean;
    @observable userSessionCountLimit: number;
    @observable userSessionCountLimitEnabled: boolean;
    @observable formCaptchaEnabled: boolean = false;
    @observable checkoutCaptchaEnabled: boolean = false;
    @observable formCaptchaSkipKnownVisitor: boolean = false;
    @observable formCaptchaType: FormCaptchaType = FormCaptchaType.Puzzle;
    @observable deductionEnabled: boolean = false;
    @observable deduction: number;
    @observable phoneCountryId: string | null = null;
    @observable consentDocuments?: RegistrationConsent[];
    @observable consentsDraft: RegistrationConsentDraft[] = [];

    @action update(settings: Partial<SchoolSettings>, allowUndefined = false) {
        super.update(settings, allowUndefined);
    }

    copy() {
        return new SchoolSettings({
            id: this.id,
            isRegistrationAgreementEnabled: this.isRegistrationAgreementEnabled,
            registrationAgreementText: this.registrationAgreementText,
            isCookieNotificationEnabled: this.isCookieNotificationEnabled,
            cookieNotificationText: this.cookieNotificationText,
            footerHtml: this.footerHtml,
            isPageFooterEnabled: this.isPageFooterEnabled,
            isLearnPageFooterEnabled: this.isLearnPageFooterEnabled,
            userSessionCountLimit: this.userSessionCountLimit,
            userSessionCountLimitEnabled: this.userSessionCountLimitEnabled,
            formCaptchaEnabled: this.formCaptchaEnabled,
            checkoutCaptchaEnabled: this.checkoutCaptchaEnabled,
            formCaptchaSkipKnownVisitor: this.formCaptchaSkipKnownVisitor,
            formCaptchaType: this.formCaptchaType,
            deductionEnabled: this.deductionEnabled,
            deduction: this.deduction,
            phoneCountryId: this.phoneCountryId,
            consentDocuments: this.consentDocuments?.map(c => c.copy()),
            consentsDraft: this.consentsDraft.map(c => ({ ...c })),
        });
    }

    static fromJson(json: any) {
        const consentDocuments = json.consentDocuments && Array.isArray(json.consentDocuments)
            ? json.consentDocuments
                .filter((d: any) => !d.deletionInfo?.isDeleted)
                .map((d: any) => {
                    const file = d.file ? AccelFile.fromJson(d.file) : null;
                    
                    if (file && d.fileId) {
                        file.update({ id: d.fileId });
                    }
                    return RegistrationConsent.fromJson({
                        id: d.id,
                        version: d.versionId ?? d.id,
                        consentText: d.text || '',
                        consentFileId: d.fileId,
                        sortOrder: d.order ?? 0,
                        isActive: true,
                        isDeleted: d.deletionInfo?.isDeleted ?? false,
                        file: file
                    });
                })
            : [];

        return new SchoolSettings({
            ...json,
            footerHtml: json.footerText,
            consentDocuments
        });
    }
}